import {
  IGlobalConfig,
  PerOrgPausableService
} from '@dadohr/shared/domainTypes/globalConfig';

export type DisabledOrgs = NonNullable<IGlobalConfig['disabledOrgs']>;

export const PER_ORG_PAUSABLE_SERVICES: {
  key: PerOrgPausableService;
  label: string;
}[] = [
  { key: 'schedules', label: 'Schedules' },
  { key: 'automations', label: 'Automations' }
];

/** The org IDs paused for `service`; `[]` for a missing or malformed list. */
export const getPausedOrgIds = (
  disabledOrgs: DisabledOrgs | undefined,
  service: PerOrgPausableService
): string[] => {
  const list = disabledOrgs?.[service];
  return Array.isArray(list) ? list : [];
};

/** Whether `orgId` is on the per-org pause list for `service` (ignores the global switch). */
export const isOrgPaused = (
  disabledOrgs: DisabledOrgs | undefined,
  service: PerOrgPausableService,
  orgId: string
): boolean => getPausedOrgIds(disabledOrgs, service).includes(orgId);

/**
 * Returns a new `disabledOrgs` map with `orgId` added to / removed from the
 * `service` list. Idempotent, never duplicates, leaves other services untouched,
 * and replaces a malformed (non-array) list with a clean one.
 */
export const withOrgPaused = (
  disabledOrgs: DisabledOrgs | undefined,
  service: PerOrgPausableService,
  orgId: string,
  paused: boolean
): DisabledOrgs => {
  const rest = getPausedOrgIds(disabledOrgs, service).filter((id) => id !== orgId);
  return {
    ...(disabledOrgs || {}),
    [service]: paused ? [...rest, orgId] : rest
  };
};
